import React, { useState, useCallback, useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { api } from '../utils/api';
import { trackEvent } from '../utils/analytics';

export default function PlaidConnectButton({ onSuccess, label = '+ Connect Account', style }) {
  const [linkToken, setLinkToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const getLinkToken = async () => {
    trackEvent('connect_account_clicked');
    setLoading(true);
    try {
      const data = await api.createLinkToken();
      setLinkToken(data.linkToken);
    } catch (err) {
      console.error('Link token error:', err);
      setLoading(false);
    }
  };

  const onPlaidSuccess = useCallback(
    async (publicToken, metadata) => {
      try {
        await api.exchangeToken(
          publicToken,
          metadata.institution?.name,
          metadata.institution?.institution_id
        );
        trackEvent('bank_account_connected');
        onSuccess();
      } catch (err) {
        console.error('Exchange error:', err);
      } finally {
        setLinkToken(null);
        setLoading(false);
      }
    },
    [onSuccess]
  );

  const onPlaidExit = useCallback(() => {
    // Reset so the button goes back to its initial state whether the user
    // completed Link or backed out of it
    setLinkToken(null);
    setLoading(false);
  }, []);

  const { open, ready } = usePlaidLink({
    token: linkToken,
    onSuccess: onPlaidSuccess,
    onExit: onPlaidExit,
  });

  // Auto-open the moment Link is actually ready, rather than requiring a
  // second click after the token finishes loading
  useEffect(() => {
    if (linkToken && ready) {
      open();
    }
  }, [linkToken, ready, open]);

  return (
    <button
      style={style || styles.connectBtn}
      onClick={getLinkToken}
      disabled={loading || (linkToken && !ready)}
    >
      {loading || (linkToken && !ready) ? 'Loading...' : label}
    </button>
  );
}

const styles = {
  connectBtn: {
    background: '#00d4aa',
    color: '#0a0f1e',
    border: 'none',
    borderRadius: '8px',
    padding: '0.6rem 1rem',
    fontSize: '0.85rem',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
  },
};
